<template>
  <div>
    <v-list-item dense>
      <v-list-item-content>
        <v-list-item-title class="d-flex align-center text-subtitle-1">
          <div class="justify-start flex-fill text-truncate my-2 mb-sm-0">
            {{ item.name }} -
            {{ item.children ? item.children.length : 1 }}
            school(s)
          </div>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="showChildren ? 'primary' : ''"
                :outlined="showChildren"
                @click.stop=""
                icon
                v-bind="attrs"
                v-on="on"
                @click="showChildren = !showChildren"
                class="d-none d-sm-inline"
                ><font-awesome-icon icon="school"></font-awesome-icon
              ></v-btn>
            </template>
            <span
              ><template v-if="showChildren">Hide</template>
              <template v-else>Show</template> School Results</span
            >
          </v-tooltip>
          <v-tooltip top v-for="report in reports" :key="report.label">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('toggle-report', {
                    districtId: item.id,
                    schoolId: null,
                    name: report.name,
                    settings: report.settings
                  })
                "
                :disabled="disableReport(item)"
                class="d-none d-sm-inline"
                ><font-awesome-icon
                  v-if="report.icon"
                  :icon="report.icon"
                ></font-awesome-icon
              ></v-btn>
            </template>
            <span>{{ report.label }}</span>
          </v-tooltip>
        </v-list-item-title>
        <v-list-item-content class="pt-0 d-flex">
          <percentage-complete
            bar-color="primary"
            background-color="grey lighten-2"
            percentage-label="Response Rate"
            :value="item.responses"
            :total="item.invitees"
          ></percentage-complete>
          <div class="text-right d-block d-sm-none">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="showChildren ? 'primary' : ''"
                  :outlined="showChildren"
                  @click.stop=""
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="showChildren = !showChildren"
                  class=""
                  ><font-awesome-icon icon="school"></font-awesome-icon
                ></v-btn>
              </template>
              <span
                ><template v-if="showChildren">Hide</template>
                <template v-else>Show</template> School Results</span
              >
            </v-tooltip>
            <v-tooltip top v-for="report in reports" :key="report.label">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    $emit('toggle-report', {
                      districtId: item.id,
                      schoolId: null,
                      name: report.name,
                      settings: report.settings
                    })
                  "
                  :disabled="disableReport(item)"
                  ><font-awesome-icon
                    v-if="report.icon"
                    :icon="report.icon"
                  ></font-awesome-icon
                ></v-btn>
              </template>
              <span>{{ report.label }}</span>
            </v-tooltip>
          </div>
        </v-list-item-content>
      </v-list-item-content>
    </v-list-item>

    <v-expand-transition :key="item.name + '_children'">
      <div v-if="showChildren">
        <v-list-item-content class="grey lighten-3 pl-md-6">
          <table class="d-none d-md-table">
            <tr
              v-for="(child, cIndex) in item.children ? item.children : [item]"
              v-bind:key="child.name + '_child'"
            >
              <td class="pl-2 w-0 text-no-wrap text-subheadline-2">
                {{ child.name }}
              </td>
              <td class="px-6 w-100 pt-4">
                <percentage-complete
                  bar-color="secondary"
                  background-color="white"
                  percentage-label="Response Rate"
                  :value="child.responses"
                  :total="child.invitees"
                ></percentage-complete>
              </td>
              <td class="pr-4 pl-1 w-0 text-no-wrap">
                <template v-for="report in reports">
                  <v-tooltip
                    top
                    :key="child.name + '_child_' + cIndex + report.label"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        @click.stop=""
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $emit('toggle-report', {
                            districtId: item.id,
                            schoolId: child.id,
                            name: report.name,
                            settings: report.settings
                          })
                        "
                        :disabled="disableReport(child)"
                        ><font-awesome-icon
                          v-if="report.icon"
                          :icon="report.icon"
                        ></font-awesome-icon
                      ></v-btn>
                    </template>
                    <span>{{ report.label }}</span>
                  </v-tooltip></template
                >
              </td>
            </tr>
          </table>

          <div class="d-block d-md-none">
            <v-list-item
              dense
              v-for="child in item.children ? item.children : [item]"
              v-bind:key="child.name + '_child'"
            >
              <v-list-item-content class="py-0">
                <v-list-item-title class="d-flex align-center text-subtitle-2">
                  <div class="justify-start flex-fill">
                    {{ child.name }}
                  </div>

                  <v-tooltip top v-for="report in reports" :key="report.label">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          $emit('toggle-report', {
                            districtId: item.id,
                            schoolId: child.id,
                            name: report.name,
                            settings: report.settings
                          })
                        "
                        :disabled="disableReport(child)"
                        ><font-awesome-icon
                          v-if="report.icon"
                          :icon="report.icon"
                        ></font-awesome-icon
                      ></v-btn>
                    </template>
                    <span>{{ report.label }}</span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-content class="pt-0 d-flex">
                  <percentage-complete
                    bar-color="secondary"
                    background-color="grey lighten-4"
                    percentage-label="Response Rate"
                    :value="child.responses"
                    :total="child.invitees"
                  ></percentage-complete>
                </v-list-item-content>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-item-content>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import numeral from "numeral";
import PercentageComplete from "../../../components/Bar.PercentageComplete.vue";

export default {
  components: { PercentageComplete },
  filters: {
    percentage(val) {
      return numeral(val).format("0.00%");
    }
  },
  props: {
    item: Object,
    reports: Object,
    disableReport: Function
  },
  data: () => ({
    showChildren: false
  })
};
</script>
